<template>
  <div>
    <div class="topic">
      <div class="pic"><img src="/static/img/story.jpg" width="100%" alt="鲨湾科技专注打造智能电动出行产品"></div>
      <div class="company">
        <div class="fs_big">鲨湾科技</div>
        <div class="companycontent">创立于 2018 年 8 月，<br/>是一家打造智能电动出行产品及服务的新锐科技公司，致力于用汽车科技重塑电动两轮车行业，<br/>为用户提供适用于中短途出行的高科技解决方案。</div>
      </div>
      <!-- <div class="tobottom"><img src="/static/img/tobottom.png" width="100%" alt=""></div> -->
    </div>
    <div class="content">
      <div class="content_top">鲨湾核心团队组建于 2014 年，成员来自电动汽车、通信电子、共享出行及互联网等行业，为大型品牌商提供电动两轮车的软硬件整体解决方案，包括整车设计、车载智能控制系统、车联网平台服务和用户软件等。<br/><br/>在该领域深耕数年之后，团队已在供应链管理、市场研究和渠道拓展等方面积累了丰富经验和资源，同时意识到当前市面上的两轮出行类产品无法承载自主研发的先进技术和数据运营的优势，于是决定二次创业。鲨湾科技应时而生、应势而生，以智能电动汽车级的技术和设计、专业竞赛摩托级的工艺和品控，对电动两轮车进行颠覆式的创新，为用户创造如呼吸般自然舒畅的骑行体验。<br/><br/>在车联网和人工智能技术兴起的风口，鲨湾科技开创全新品牌“蓝鲨智能摩托”。2019年 7 月 3 日，蓝鲨在北京举办品牌及新品战略发布会，旗下首款产品“蓝鲨 R 系列”正式亮相，用汽车科技创造智能电动摩托车。<br/><br/>蓝鲨团队秉承“归零、自驱、开放”的价值观，并将在可预见的未来，通过自主设计研发的产品和服务，让智能电动摩托车风靡全球。</div>
      <div class="content_bottom">
        <div class="subtitle color_gray">公司定位</div>
        <div class="fs_normal">专注于研发与设计智能电动出行产品的科技公司</div>
        <div class="subtitle color_gray">品牌使命</div>
        <div class="fs_normal">让智能电动摩托车风靡全球</div>
        <div class="subtitle color_gray">企业愿景</div>
        <div class="fs_normal">用汽车科技重塑电动两轮车行业</div>
        <div class="subtitle color_gray">价值观</div>
        <div class="fs_normal">归零 自驱 开放</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  mounted(){
    let that = this
    window.scrollTo(0,0)
    this.$nextTick(function(){
      window.addEventListener("scroll", that.animateTxt);
    })
  },
  beforeDestroy(){
    window.removeEventListener("scroll", this.animateTxt);
  },
  methods: {
    animateTxt(){
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if(top <= 100){
        this.$emit("hidenav");
      } else {
        this.$emit("shownav");
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.topic{
  position: relative;
  .pic{
    font-size: 0;
  }
  .company{
    position: absolute;
    text-align: center;
    width: 100%;
    color: #fff;
    top: 15vw;
    .companycontent{
      margin-top: 30px;
      line-height: 30px;
    }
  }
  .tobottom{
    position: absolute;
    width: 20px;
    margin: 0 auto;
    left: 0;
    right: 0;
    bottom: 3vw;
  }
}
.content{
  padding: 5vw 0;
  .content_top{
    width: 42%;
    margin: 0 auto;
    color: #666;
    line-height: 30px;
    padding-bottom: 4vw;
    border-bottom: 1px solid #ddd;
  }
  .content_bottom{
    width: 42%;
    margin: 0 auto;
    .subtitle{
      margin-top: 50px;
      margin-bottom: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tw/story.vue